import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/geographicZones/${COMMON_QUERY_PARAMS.ID}`;

export const deleteGeographicZoneCommand = async ({
  sellerId,
  id,
}: {
  sellerId: string;
  id: string;
}): Promise<BaseBackResponse | BackResponseFailure> => {
  try {
    const response = await apiCall<BaseBackResponse>(
      ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId).replace(
        COMMON_QUERY_PARAMS.ID,
        id,
      ),
      {
        method: SUPPORTED_METHODS.DELETE,
      },
    );

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
